module.exports = __webpack_public_path__ + "static/media/223HO.2262f1eb.jpg";